//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, inject, OnInit } from '@angular/core';

//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { firstValueFrom } from 'rxjs';

//-================ IMPORTS FOR CONSTANTS ================-\\

//-================ IMPORTS FOR DEPENDENCIES ================-\\

//-================ IMPORTS FOR INTERFACES ================-\\
import { HEADERS_CDMS } from 'src/app/Interfaces/Admin/Haders_Admin.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { GeneralRoleCDMS, typeRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';


@Component({
    selector: 'app-admin-headerof-cdms',
    templateUrl: './admin-headerof-cdms.component.html',
    styleUrls: ['./admin-headerof-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class AdminHeaderofCDMSComponent implements OnInit {

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //-========================= SERVICES =========================-\\
  public UserService = inject(UserDataService);
  private LibMasterService = inject(LibraryMasterService);

  //+================== VARIABLES FOR CARDS HEADERS ==================+\\
  public HeadersCDMS: HEADERS_CDMS[] = [
    //{ Title: 'CCP', Description: '', Tooltip: 'Clic para modificar', RouterLink: '/Dashboard/Admin/AdminHeadersLB/EditHeaderCCP', Icon: 'fa-newspaper', IconButton: 'fa-pen-to-square', Roles: [this.RolesGeneral.AdministratorCCP] },
    {
      Title: 'Processes',
      Description: '',
      Tooltip: 'Clic para modificar',
      RouterLink: '/Dashboard/Admin/AdminHeadersLB/EditHeaderFIN',
      Icon: 'fa-newspaper',
      IconButton: 'fa-pen-to-square',
      Roles: [this.RolesGeneral.AdministratorFIN, this.RolesGeneral.SuperAdministrator]
    },
  ];

  ngOnInit(): void {
    this.LoadDynamicLibraries();
  }

  private async LoadDynamicLibraries(): Promise<void> {
    try {
      const res = await firstValueFrom(this.LibMasterService.Get_Active_Libraries());
      if (res.success && Array.isArray(res.operation)) {
        for (const lib of res.operation) {
          const slug = String(lib?.Slug || '').trim().toUpperCase();
          
          // Omitimos CCP si está desactivada como solicitó el usuario
          if (slug === 'CCP') continue;

          const administratorRole = `Administrator${slug}` as typeRoleCDMS;

          this.HeadersCDMS.push({
            Title: lib.Nombre,
            Description: '',
            Tooltip: 'Clic para modificar',
            RouterLink: `/Dashboard/Admin/AdminHeadersLB/EditHeaderMaster/${lib.Slug}`,
            Icon: 'fa-table-columns',
            IconButton: 'fa-pen-to-square',
            Roles: [administratorRole, this.RolesGeneral.SuperAdministrator]
          });
        }
      }
    } catch (e) {
      console.error('Error loading dynamic libraries for header admin:', e);
    }
  }
}

